import { queryOptions } from '@tanstack/react-query'
import { apiGet, apiPost } from './client'
import type { CronAnswer } from './cronAnswer'

/**
 * Settings → Easeedesk → Assigning auto escalation.
 *
 * Perechile vechi: `settings/easeedesk/assigning_auto_escalation`,
 * `assign_auto_escalation_profile`, `rebuild_auto_escalation_configuration`.
 *
 * `apiGet` / `apiPost` pun ELE `/api/v2` in fata caii.
 */

export interface AssignableStatus {
  ID: number
  status_name: string
  /** Profilul legat acum; 0 = niciunul. */
  profile_id: number
}

export interface AssignableTicketType {
  ID: number
  type_name: string
  short_name: string
  color_identifier: string
  workflow_id: number
  statuses: AssignableStatus[]
}

export interface AssignAutoEscalationPage {
  title: string
  moduleUrl: string
  profiles: { ID: number; profile_name: string }[]
  ticket_types: AssignableTicketType[]
}

export function assignAutoEscalationQuery() {
  return queryOptions({
    queryKey: ['settings', 'easeedesk', 'assigning_auto_escalation'],
    queryFn: () => apiGet<AssignAutoEscalationPage>('/settings/easeedesk/assigning_auto_escalation'),
  })
}

export function assignAutoEscalationProfile(ticket_type: number, ticket_status: number, profile_id: number) {
  return apiPost<{ ok?: boolean; profile_id?: number }>('/settings/easeedesk/assigning_auto_escalation', {
    'options[ticket_type]': ticket_type,
    'options[ticket_status]': ticket_status,
    'options[profile_id]': profile_id,
  })
}

export function rebuildAutoEscalationCron() {
  return apiPost<CronAnswer>(
    '/settings/easeedesk/assigning_auto_escalation/rebuild_cron',
    {},
  )
}
